var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleet01 = function SvgSleet01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.66,
    y1: 176.66,
    x2: 161.96,
    y2: 15.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 48.26,
    y1: 224.26,
    x2: 209.56,
    y2: 62.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 8.91,
    y1: 184.91,
    x2: 170.22,
    y2: 23.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 56.59,
    y1: 232.59,
    x2: 217.9,
    y2: 71.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 19.34,
    y1: 195.34,
    x2: 180.64,
    y2: 34.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -7.65,
    y1: 168.35,
    x2: 153.65,
    y2: 7.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 7.6,
    y1: 183.6,
    x2: 168.91,
    y2: 22.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 38.08,
    y1: 214.08,
    x2: 199.38,
    y2: 52.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 33.73,
    y1: 209.73,
    x2: 195.03,
    y2: 48.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 65.23,
    y1: 241.23,
    x2: 226.54,
    y2: 79.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 61.34,
    y1: 237.34,
    x2: 222.64,
    y2: 76.04,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M151.81,28.61c-3.18,0-6.44.43-9.87,1.31C133.54,11.64,115.6,0,95.35,0,72.91,0,53.24,14.36,46.4,35.73c-.62,1.93.44,4,2.38,4.62,1.94.62,4-.44,4.62-2.38,5.86-18.31,22.72-30.62,41.95-30.62,17.09,0,32.25,9.68,39.58,24.95-5.04,2.31-8.53,5.71-10.67,8.43-1.26,1.59-.98,3.9.61,5.16.67.53,1.47.79,2.27.79,1.09,0,2.16-.48,2.89-1.4,1.99-2.52,5.48-5.85,10.81-7.38.02,0,.1-.03.13-.04,3.92-1.28,7.46-1.9,10.85-1.9,19.41,0,35.21,15.79,35.21,35.21s-15.79,35.21-35.21,35.21H39.5c-14.62,0-26.52-11.89-26.52-26.52s11.9-26.52,26.52-26.52c2.16,0,4.42.35,7.1,1.1,3.52,1.06,6.78,2.96,9.19,5.36.72.71,1.65,1.07,2.59,1.07s1.89-.36,2.61-1.08c1.43-1.44,1.42-3.76-.02-5.2-3.26-3.24-7.62-5.8-12.28-7.2-.01,0-.02,0-.04,0-.01,0-.02-.01-.03-.02-3.37-.94-6.26-1.39-9.12-1.39-18.68,0-33.87,15.19-33.87,33.87s15.19,33.86,33.87,33.86h112.3c23.47,0,42.56-19.09,42.56-42.56,0-23.47-19.09-42.56-42.56-42.56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.5,122.26c-7.06,0-12.77,5.71-12.77,12.77s5.71,12.77,12.77,12.77,12.76-5.71,12.76-12.77-5.71-12.76-12.76-12.77M137.5,141.25c-3.44,0-6.23-2.79-6.23-6.23s2.79-6.23,6.23-6.23,6.23,2.79,6.23,6.23-2.79,6.23-6.23,6.23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.11,153.95c-7.05,0-12.76,5.72-12.76,12.77s5.71,12.77,12.77,12.76c7.06,0,12.76-5.71,12.76-12.77-.01-7.04-5.72-12.74-12.76-12.76M27.12,172.94c-3.44,0-6.23-2.79-6.23-6.23s2.78-6.23,6.22-6.23,6.23,2.78,6.24,6.22c0,3.44-2.79,6.23-6.23,6.24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.6,169.18c-8.52,0-15.41,6.89-15.41,15.41s6.9,15.41,15.41,15.41,15.41-6.89,15.41-15.41-6.9-15.4-15.41-15.41M104.6,193.47c-4.9,0-8.88-3.97-8.88-8.87s3.98-8.87,8.88-8.87,8.87,3.97,8.87,8.87-3.98,8.87-8.87,8.87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M82.3,122.26c-5.59,0-10.12,4.52-10.12,10.12s4.53,10.11,10.12,10.12c5.59,0,10.13-4.52,10.13-10.12s-4.53-10.12-10.13-10.12M82.3,135.97c-1.98,0-3.59-1.6-3.59-3.59s1.61-3.59,3.59-3.59,3.59,1.61,3.59,3.59-1.61,3.59-3.59,3.59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M27.11,144.93h0c-1.84,0-3.32-1.49-3.32-3.32v-16.03c0-1.84,1.49-3.32,3.32-3.32s3.32,1.49,3.32,3.32v16.03c0,1.84-1.49,3.32-3.32,3.32"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M54.71,150.74h0c-1.84,0-3.32-1.49-3.32-3.32v-21.84c0-1.84,1.49-3.32,3.32-3.32s3.32,1.49,3.32,3.32v21.84c0,1.84-1.49,3.32-3.32,3.32"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.9,160.94h0c-1.84,0-3.32-1.49-3.32-3.32v-30.7c0-1.84,1.49-3.32,3.32-3.32s3.32,1.49,3.32,3.32v30.7c0,1.84-1.49,3.32-3.32,3.32"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M72.71,190.96h0c-1.84,0-3.32-1.49-3.32-3.32v-33.77c0-1.84,1.49-3.32,3.32-3.32s3.32,1.49,3.32,3.32v33.77c0,1.84-1.49,3.32-3.32,3.32"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.8,183.91h0c-1.84,0-3.32-1.49-3.32-3.32v-21.84c0-1.84,1.49-3.32,3.32-3.32s3.32,1.49,3.32,3.32v21.84c0,1.84-1.49,3.32-3.32,3.32"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M165.09,144.93h0c-1.84,0-3.32-1.49-3.32-3.32v-16.03c0-1.84,1.49-3.32,3.32-3.32s3.32,1.49,3.32,3.32v16.03c0,1.84-1.49,3.32-3.32,3.32"
  })));
};
export default SvgSleet01;